import React from 'react';
import { BellOutlined } from '@ant-design/icons';
import { HandleNotificationsModal } from '../../Modals/HandleNotificationsModal';
import { useNotificationButton } from './useNotificationButton';
import * as S from './styles';

export function NotificationButton() {
	const {
		isLoading,
		isEnabled,
		isUpdating,
		modalTitle,
		isModalOpen,
		handleOpenModal,
		handleCancelModal,
		handleConfirmModal
	} = useNotificationButton();

	const defaultButtonProps = {
		icon: <BellOutlined />,
		onClick: handleOpenModal
	};

	return (
		<>
			{isLoading ? (
				<S.BellButton loading {...defaultButtonProps} />
			) : isEnabled ? (
				<S.BellButton type="primary" {...defaultButtonProps} />
			) : (
				<S.DisabledBellButton {...defaultButtonProps} />
			)}
			<HandleNotificationsModal
				loading={isUpdating}
				isEnabled={isEnabled}
				visible={isModalOpen}
				customMessage={modalTitle}
				onCancel={handleCancelModal}
				onConfirm={handleConfirmModal}
			/>
		</>
	);
}
